import { render, staticRenderFns } from "./QuestionnaireBlocksTable.vue?vue&type=template&id=4b6410ad&scoped=true"
import script from "./QuestionnaireBlocksTable.vue?vue&type=script&lang=js"
export * from "./QuestionnaireBlocksTable.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireBlocksTable.vue?vue&type=style&index=0&id=4b6410ad&prod&lang=css"
import style1 from "./QuestionnaireBlocksTable.vue?vue&type=style&index=1&id=4b6410ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6410ad",
  null
  
)

export default component.exports